<div class="login-left-panel">
  <div class="login-content">
    <div class="logo-container">
      <img [src]="mainLogo" alt="Logo" class="logo">
    </div>

    <h2 class="welcome-title">Para entrar no sistema informe seus dados abaixo</h2>

    <form (ngSubmit)="onSubmit()" class="login-form">
      <div class="form-group">
        <label for="email" class="form-label">E-mail</label>
        <input
          id="email"
          type="email"
          class="form-input"
          placeholder="seu@email.com"
          name="login"
          [(ngModel)]="loginModel.login"
          autofocus
        />
      </div>

      <div class="form-group">
        <label for="password" class="form-label">Senha</label>
        <input
          id="password"
          type="password"
          class="form-input"
          placeholder="Sua senha"
          name="password"
          [(ngModel)]="loginModel.password"
        />
      </div>

      <button type="submit" class="login-button">
        Entrar
      </button>
    </form>

    <div class="login-links">
      <a href="#" class="link">Esqueci minha senha</a>
      
    </div>

    <!-- <div class="signup-section">
      <p>Ainda não possui uma conta?</p>
      <a href="#" class="link-primary">Fale com um consultor</a>
    </div> -->
  </div>
</div>
